import Vue from 'vue'
import App from '@/models/App'
import Ship from '@/models/Ship'
import Organization from '@/models/Organization'

export default class ShipDaily extends App {
    static get entity() {
        return 'ShipDailies'
    }
    static findById(id) {
        return this.query().whereId(id).withAllRecursive().first()
    }
    static latestByShipId(shipId) {
        return this.query()
            .where('shipId', shipId)
            .withAllRecursive()
            .orderBy('registeredAt', 'desc')
            .first()
    }
    static latestByShipVoyageNo(shipId, voyageNo) {
        return this.query()
            .where('shipId', shipId)
            .where('voyageNo', voyageNo)
            .withAllRecursive()
            .orderBy('registeredAt', 'desc')
            .first()
    }
    static newestByShipVoyageNo(shipId, voyageNo) {
        return this.query()
            .where('shipId', shipId)
            .where('voyageNo', voyageNo)
            .withAllRecursive()
            .orderBy('registeredAt', 'asc')
            .first()
    }
    static newestByShipVoyageNoDeparture(shipId, voyageNo) {
        return this.query()
            .where('shipId', shipId)
            .where('voyageNo', voyageNo)
            .where('type', 'Departure')
            .withAllRecursive()
            .orderBy('registeredAt', 'desc')
            .first()
    }
    static fetchByShipVoyageNo(shipId, voyageNo) {
        return this.query()
            .where('shipId', shipId)
            .where('voyageNo', voyageNo)
            .withAllRecursive()
            .orderBy('registeredAt', 'asc')
            .get()
    }
    static fetchByShipId(shipId) {
        return this.query()
            .where('shipId', shipId)
            .withAllRecursive()
            .orderBy('id', 'desc')
            .get()
    }
    static all() {
        return this.query()
            .withAllRecursive()
            .orderBy('voyageNo', 'desc')
            .orderBy('registeredAt', 'desc')
            .orderBy('createdAt', 'desc')
            .get()
    }
    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            shipId: this.attr(''),
            type: this.attr(''),
            voyageNo: this.attr(0),
            engineRpm: this.attr(0),
            direction: this.attr(0),
            currentSpeed: this.attr(0),
            averageSpeed: this.attr(0),
            lsmgo: this.attr(0),
            lsof: this.attr(0),
            freshWater: this.attr(0),
            usedLsmgo: this.attr(0),
            usedLsfo: this.attr(0),
            mileage: this.attr(0),
            distance: this.attr(0),
            comment: this.attr(''),
            departurePort: this.attr(''),
            arrivalPort: this.attr(''),
            mooringPort: this.attr(''),
            nextPort: this.attr(''),
            longitude10: this.attr(''),
            lonDirection: this.attr(''),
            lonDegree: this.attr(''),
            lonMinute: this.attr(''),
            lonSecond: this.attr(''),
            latitude10: this.attr(''),
            latDirection: this.attr(''),
            latDegree: this.attr(''),
            latMinute: this.attr(''),
            latSecond: this.attr(''),
            weather: this.attr(''),
            expectedArrival: this.attr(''),
            cargoCondition: this.attr(''),
            stateTank: this.attr(''),
            registeredAt: this.attr(''),
            arrivedAt: this.attr(''),
            arrivalAt: this.attr(''),
            departedAt: this.attr(''),
            departureAt: this.attr(''),
            createdAt: this.attr(''),
            value01: this.attr(''),
            value02: this.attr(''),
            value03: this.attr(''),
            value04: this.attr(''),
            value05: this.attr(''),
            value06: this.attr(''),
            value07: this.attr(''),
            value08: this.attr(''),
            value09: this.attr(''),
            value10: this.attr(''),
            organization: this.belongsTo(Organization, 'organizationId'),
            ship: this.belongsTo(Ship, 'shipId'),
        }
    }
    static apiConfig = {
        actions: {
            fetch(shipId, params) {
                return this.get(`${shipId}/dailies`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            create(params) {
                return this.post(`/dailies`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'dailyReport',
                    baseURL: App.apiURL(),
                })
            },
            update(params) {
                return this.patch(`/dailies`, App.patch(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'dailyReport',
                    baseURL: App.apiURL(),
                })
            },
            import(shipId, params) {
                return this.post(`${shipId}/dailies/import`, App.post(params), {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'dailyReport',
                    baseURL: App.apiURL(),
                })
            },
            destroy(shipId, dailyId) {
                return this.delete(`${shipId}/dailies/${dailyId}`, {
                    params: {},
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    delete: dailyId,
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
